/* global Dialog */
import { Controller } from '@hotwired/stimulus'

// Envía el reporte por fetch y mantiene el diálogo bajo control.
//
// El envío se intercepta desde connect() y sin `{ once: true }`: antes el listener se
// registraba al abrir el diálogo y se consumía en el primer envío, de modo que cualquier fallo
// dejaba el formulario sin controlador y el siguiente envío se iba por navegación normal del
// navegador — a la respuesta sin layout del endpoint, sin salida (TDT-RNK-3941).
export default class extends Controller {
  static targets = ['form', 'error']
  static values = { reportado: Boolean }

  connect () {
    if (this.reportadoValue) {
      this.closeDialog()
      return
    }

    if (!this.hasFormTarget) return

    this.submitHandler = (event) => this.handleSubmit(event)
    this.formTarget.addEventListener('submit', this.submitHandler)
  }

  disconnect () {
    if (this.submitHandler && this.hasFormTarget) {
      this.formTarget.removeEventListener('submit', this.submitHandler)
    }
  }

  start (event) {
    event.preventDefault()
    if (this.reportadoValue || !this.hasFormTarget) return

    this.pb = new Dialog(this.formTarget, { title: 'Reportar', closingx: true })
  }

  closeDialog () {
    if (this.pb) {
      this.pb.destroy()
      this.pb = null
    }
  }

  async handleSubmit (event) {
    event.preventDefault()
    const form = event.target
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    this.hideError()

    try {
      const response = await fetch(form.action, {
        method: form.method || 'POST',
        headers: { 'X-CSRF-Token': token, 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
        credentials: 'same-origin'
      })

      if (!response.ok) return this.showError()

      const html = await response.text()
      const doc = new DOMParser().parseFromString(html, 'text/html')
      const newElement = doc.body.firstElementChild

      this.closeDialog()
      this.element.replaceWith(newElement)
      this.showSuccessMessage(newElement)
    } catch (_error) {
      this.showError()
    }
  }

  // Un fallo silencioso dejaba al usuario sin saber si su reporte había llegado, y reintentando
  // sobre un formulario que ya no interceptaba nadie. El formulario sigue usable tras el error.
  showError () {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = 'No se ha podido enviar el reporte. Inténtalo de nuevo.'
    this.errorTarget.classList.remove('hidden')
  }

  hideError () {
    if (!this.hasErrorTarget) return

    this.errorTarget.classList.add('hidden')
  }

  showSuccessMessage (container) {
    const successMessage = document.createElement('div')
    successMessage.className = 'rnk-Flash-success'
    successMessage.style.margin = '0'
    successMessage.textContent = 'Tu reporte se ha enviado con éxito'

    const starter = container.querySelector('.rnk-Reportar_Starter')
    if (starter) {
      starter.insertAdjacentElement('afterend', successMessage)
      this.hideAfterDelay(successMessage)
    }
  }

  hideAfterDelay (element) {
    setTimeout(() => {
      element.style.transition = 'opacity 0.5s'
      element.style.opacity = '0'
      setTimeout(() => element.remove(), 500)
    }, 5000)
  }
}
